import { skipToken, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ExistingDestination, Transfer } from "@prequel/react";

import TransfersService from "@/api/services/transfers";
import { useToast } from "@/providers/ToastProvider";

export function useTransfer(transferId: Transfer["id"] | undefined) {
  return useQuery({
    queryKey: ["transfers", "detail", transferId],
    queryFn: transferId ? () => TransfersService.getTransferByID(transferId!) : skipToken,
  });
}

export function usePostTransfer() {
  const queryClient = useQueryClient();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: (payload: {
      destinationID: ExistingDestination["id"];
      fullRefresh: boolean;
      models?: string[];
      startTransferWindowAt?: string;
      endTransferWindowAt?: string;
      tags?: Record<string, string>;
    }) => TransfersService.postTransfer(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["transfers"] });
      queryClient.invalidateQueries({ queryKey: ["destination-activities"] });
      addToast({
        kind: "SUCCESS",
        message: `Transfer enqueued successfully!`,
      });
    },
  });
}

export function useCancelTransfer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: { transferID: Transfer["id"] }) => TransfersService.cancelExportTransfer(payload.transferID),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["transfers"] });
      queryClient.invalidateQueries({ queryKey: ["destination-activities"] });
    },
  });
}
